var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicketOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:ticket-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.16683 2.6665C2.81321 2.6665 2.47407 2.80698 2.22402 3.05703C1.97397 3.30708 1.8335 3.64622 1.8335 3.99984V6.6665C2.18712 6.6665 2.52626 6.80698 2.77631 7.05703C3.02635 7.30708 3.16683 7.64622 3.16683 7.99984C3.16683 8.35346 3.02635 8.6926 2.77631 8.94265C2.52626 9.19269 2.18712 9.33317 1.8335 9.33317V11.9998C1.8335 12.3535 1.97397 12.6926 2.22402 12.9426C2.47407 13.1927 2.81321 13.3332 3.16683 13.3332H13.8335C14.1871 13.3332 14.5263 13.1927 14.7763 12.9426C15.0264 12.6926 15.1668 12.3535 15.1668 11.9998V9.33317C14.8132 9.33317 14.4741 9.19269 14.224 8.94265C13.974 8.6926 13.8335 8.35346 13.8335 7.99984C13.8335 7.64622 13.974 7.30708 14.224 7.05703C14.4741 6.80698 14.8132 6.6665 15.1668 6.6665V3.99984C15.1668 3.64622 15.0264 3.30708 14.7763 3.05703C14.5263 2.80698 14.1871 2.6665 13.8335 2.6665H3.16683ZM3.16683 3.99984H13.8335V5.69317C13.0068 6.1665 12.5002 7.0465 12.5002 7.99984C12.5002 8.95317 13.0068 9.83317 13.8335 10.3065V11.9998H3.16683V10.3065C3.9935 9.83317 4.50016 8.95317 4.50016 7.99984C4.50016 7.0465 3.9935 6.1665 3.16683 5.69317V3.99984Z",
    fill: "#344054"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketOutline);
export default __webpack_public_path__ + "static/media/ticket-outline.635158bf9b2b87f3dfb7a2f802ab5014.svg";
export { ForwardRef as ReactComponent };